import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useRef, useEffect } from 'sb-hooks'
import Rect from '@reach/rect'

import { Consumer } from './Menu'


const close = {
  isOpen: false,
  selectionIndex: -1,
  closingWithClick: false,
}

const MenuButton = forwardRef((props, ref) => {
  const {
    onClick, onKeyDown, onMouseEnter, onMouseLeave, dataTestId, ...rest
  } = props

  const timeoutId = useRef()

  useEffect(() => () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current)
    }
  }, [])

  return (
    <Consumer>
      {
        (providerProps) => {
          const {
            refs, state, setState,
            handleMenuClick, handleMenuMouseDown, handleMenuKeyDown, handleMenuMouseEnter, handleMenuMouseLeave,
            handleMenuBlur,
          } = providerProps

          return (
            <Rect
              observe={state.isOpen}
              onChange={(buttonRect) => setState({ buttonRect })}
            >
              {
                ({ ref: rectRef }) => (
                  <button
                    data-testid={dataTestId}
                    id={state.buttonId}
                    aria-haspopup="menu"
                    aria-expanded={state.isOpen}
                    type="button"
                    ref={(node) => {
                      rectRef(node)

                      if (ref) {
                        if (typeof ref === 'function') {
                          ref(node)
                        }
                        else {
                          ref.current = node
                        }
                      }

                      refs.button = node
                    }}
                    onMouseDown={handleMenuMouseDown}
                    onBlur={handleMenuBlur}
                    onClick={(event) => {
                      handleMenuClick(event)

                      if (typeof onClick === 'function') {
                        onClick(event)
                      }
                    }}
                    onKeyDown={(event) => {
                      handleMenuKeyDown(event)

                      if (typeof onKeyDown === 'function') {
                        onKeyDown(event)
                      }
                    }}
                    onMouseEnter={(event) => {
                      handleMenuMouseEnter(event)

                      if (typeof onMouseEnter === 'function') {
                        onMouseEnter(event)
                      }
                    }}
                    onMouseLeave={(event) => {
                      handleMenuMouseLeave(close)

                      if (typeof onMouseLeave === 'function') {
                        onMouseLeave(event)
                      }
                    }}
                    {...rest}
                  />
                )
              }
            </Rect>
          )
        }
      }
    </Consumer>
  )
})

MenuButton.propTypes = {
  children: PropTypes.node,
}


export default MenuButton
